import React, { useState } from 'react';
import Popup from 'reactjs-popup';
 
const ConfirmationModalDecline = ({ isOpen, onClose, onSave, onCancel, commentMandatory, placeHolderText, notifOptions }) => {
    const [checkNotifGuest, setCheckNotifGuest] = useState(true);
    const toggleCheckNotifGuest = () => { setCheckNotifRequestor(!checkNotifGuest); setCheckNotifGuest((prevCheckNotifGuest) => !prevCheckNotifGuest); };
    const [checkNotifRequestor, setCheckNotifRequestor] = useState(true);
    const toggleCheckNotifRequestor = () => { setCheckNotifRequestor((prevCheckNotifRequestor) => !prevCheckNotifRequestor); };

    const [comment, setComment] = useState("");
    const handleCommentChange = (e) => { setComment(e.target.value); };
 
    const resetInputs = () => { setComment(""); setCheckNotifGuest(true); setCheckNotifRequestor(true);  };
 
    const handleSave = () => {
        if ((comment==="") && commentMandatory) alert("Please comment your decision."); else 
        {
            onSave(comment,(notifOptions==="true") ? checkNotifGuest : true,(notifOptions==="true") ? checkNotifRequestor : true);
            resetInputs();
        }
    };

    return (
        <Popup
            open={isOpen}
            onClose={() => {resetInputs(); onClose();}}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle' style={{ userSelect: 'none'}}>Decline</h5>
                <p className='popup-text' style={{ userSelect: 'none'}}>
                    Are you sure you want to send a &quot;Declined&quot; reply?
                </p>
                <div className="form-group" style={{ userSelect: 'none'}}>
                <label htmlFor="comment" className='text-label'>Comment</label>
                <textarea
                    id="comment"
                    rows="3"
                    placeholder={placeHolderText}
                    value={comment}
                    onChange={handleCommentChange}  // Attach the change handler
                    className='form-control popup-textarea'
                />
                </div>
                {(notifOptions==="true") && (<>
                    <div className="form-group" style={{ userSelect: 'none'}}>
                      <div className="align-items-center mb-2 d-flex">
                        <input className='form-check-input-custom2 form-check-input' type="checkbox" id="chkCheckNotifGuest" checked={checkNotifGuest} onChange={toggleCheckNotifGuest} />
                        <span className="font-mars-centra" style={{ userSelect: 'none', cursor: 'pointer'}}  onClick={toggleCheckNotifGuest}>Notify guest</span>
                      </div>
                      <div className="align-items-center mb-2 d-flex">
                        <input className={(checkNotifGuest) ? 'form-check-input-custom2 form-check-input' : 'form-check-input-greyed form-check-input' }  type="checkbox" id="chkCheckNotifRequestor" checked={checkNotifRequestor}
                                onChange={(checkNotifGuest) ? toggleCheckNotifRequestor : () => {}} />
                        <span className="font-mars-centra" 
                                style={(checkNotifGuest) ? { userSelect: 'none', cursor: 'pointer' } : { color: '#D3D3D3', userSelect: 'none', cursor: 'default' }} 
                                onClick={(checkNotifGuest) ? toggleCheckNotifRequestor : () => {}}>Notify requestor</span>
                      </div>
                    </div>
                </>)}
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        className="btn btn-cancel"
                        onClick={onCancel}
                    >
                        CANCEL
                    </button>
                    <button
                        className="btn btn-save"
                        onClick={handleSave}  // Use the local handleSave function
                    >
                        SAVE
                    </button>
                </div>
            </div>
        </Popup>
    );
};
 
export default ConfirmationModalDecline;